<template>
  <div class="upgrade-subscription" :class="{ 'upgrade-subscription--compact-layout': compactLayout }">
    <div class="upgrade-subscription__wrapper d-flex">
      <BlockContainer :class="containerClass">
        <h5 v-if="containerTitle">{{ containerTitle }}</h5>

        <a-RenderHTML v-if="containerText" :value="containerText" class="mt-4" :class="containerTextClass" />

        <div class="mt-4">
          <UpdateSubscriptionButton
            :landlord-id="landlordId"
            :tenancy-id="tenancyId"
            origin="dashboard_tenancyview_overview_subscription"
          />
        </div>
      </BlockContainer>
    </div>
  </div>
</template>

<script>
import BlockContainer from '@/components/BlockContainer.vue';
import subscription from '@/mixins/tenancy/subscription';
import i18nCommon from '@modules/i18n/mixins/Common';
import UpdateSubscriptionButton from '@/components/upsale/UpdateSubscriptionButton.vue';
import RenderHTML from '@modules/design-system/components/atoms/RenderHTML.vue';

export default {
  components: {
    BlockContainer,
    UpdateSubscriptionButton,
    'a-RenderHTML': RenderHTML,
  },
  mixins: [i18nCommon, subscription],
  props: {
    compactLayout: Boolean,
    tenancyId: [String, Number],
    landlordId: [String, Number],
  },
  computed: {
    containerClass() {
      return ['flex-fill', 'upgrade-subscription'];
    },
    containerTextClass() {
      if (this.isFree) {
        return ['mt-0'];
      } else {
        return ['mt-1'];
      }
    },
    containerTitle() {
      if (this.isBasic) {
        return this.translationUpgradeBasicSubscriptionTitle;
      } else if (this.isPremium) {
        return this.translationDowngradePremiumSubscriptionTitle;
      } else {
        return this.translationUpgradeFreeSubscriptionTitle;
      }
    },
    containerText() {
      if (this.isBasic) {
        return this.translationUpgradeBasicSubscriptionBody;
      } else if (this.isPremium) {
        return this.translationDowngradePremiumSubscriptionBody;
      } else {
        return this.translationDowngradeFreeSubscriptionTitle;
      }
    },
    translationUpgradeFreeSubscriptionTitle() {
      return null;
    },
    translationDowngradeFreeSubscriptionTitle() {
      // return this.translate('subscription.not activated');
      return 'Med abonnement får du automatisk innkreving av husleien, purring, inkasso og mye mer. Klikk oppgrader for å se alle fordelene!';
    },
    translationUpgradeBasicSubscriptionTitle() {
      return this.translate('subscription.upgrade.upgrade basic subscription heading');
    },
    translationUpgradeBasicSubscriptionBody() {
      return this.translate('subscription.upgrade.the lease has a basic subscription');
    },
    translationDowngradePremiumSubscriptionTitle() {
      return this.translate('subscription.downgrade.downgrade premium subscription heading');
    },
    translationDowngradePremiumSubscriptionBody() {
      return this.translate('subscription.downgrade.md-the lease has a premium subscription', {
        link: `https://${window.location.host}/dashboard/landlord/thanks`,
      });
    },
  },
};
</script>
<style lang="css">
.upgrade-subscription,
.upgrade-subscription__wrapper {
  @apply h-full;
}

.upgrade-subscription--compact-layout h5 {
  @apply mt-3 text-sm font-medium;
}

.upgrade-subscription.upgrade-subscription--compact-layout .upgrade-subscription {
  box-shadow: unset;
  @apply shadow-none;
}

.upgrade-subscription:not(.upgrade-subscription--compact-layout) {
  @apply w-full;
}

.upgrade-subscription:not(.upgrade-subscription--compact-layout) .upgrade-subscription {
  @apply p-5;
}
</style>
